"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emojiSearchIcons = exports.emojiCategoryIcons = void 0;
var _react = _interopRequireDefault(require("react"));
var _lucideReact = require("lucide-react");
var _Icon = require("../../forecast-v2/components/media/icon/Icon");
var _jsxRuntime = require("react/jsx-runtime");
var emojiCategoryIcons = exports.emojiCategoryIcons = {
  activity: {
    outline: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'activities'
    }),
    solid: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'activities'
    })
  },
  custom: {
    outline: /*#__PURE__*/(0, _jsxRuntime.jsx)(_lucideReact.StarIcon, {
      className: "size-full"
    }),
    // Needed to add another solid variant - outline will be used for now
    solid: /*#__PURE__*/(0, _jsxRuntime.jsx)(_lucideReact.StarIcon, {
      className: "size-full"
    })
  },
  flags: {
    outline: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'flag'
    }),
    solid: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {})
  },
  foods: {
    outline: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'food'
    }),
    solid: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {})
  },
  frequent: {
    outline: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'clock'
    }),
    solid: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'clock'
    })
  },
  nature: {
    outline: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'nature'
    }),
    solid: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'nature'
    })
  },
  objects: {
    outline: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'object'
    }),
    solid: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'object'
    })
  },
  people: {
    outline: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'emoji'
    }),
    solid: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'emoji'
    })
  },
  places: {
    outline: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'locations'
    }),
    solid: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'locations'
    })
  },
  symbols: {
    outline: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'symbols'
    }),
    solid: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'symbols'
    })
  }
};
var emojiSearchIcons = exports.emojiSearchIcons = {
  delete: /*#__PURE__*/(0, _jsxRuntime.jsx)(_lucideReact.DeleteIcon, {
    className: "size-4"
  }),
  loupe: /*#__PURE__*/(0, _jsxRuntime.jsx)(_lucideReact.SearchIcon, {
    className: "size-4"
  })
};